<template>
  <div class="datanalysis">
    <div class="swiperBox">
      <div class="carouselBox">
          <el-carousel @change="carouselChange" trigger="click" height="394px">
            <el-carousel-item v-for="(item, index) in menuList" :key="index">
            </el-carousel-item>
          </el-carousel>
        <div class="block">
          <span style="position: absolute;z-index: -99999999999;">{{currentSwiperIndex}}</span>

          <div class="itemBox" v-if="currentSwiperIndex === index" v-for="(item, index) in menuList">
            <div class="textBox">
              <div class="title">
                {{item.name}}
              </div>
            </div>
            <div class="iconBox">
              <img :src="item.icon" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="menuList.length>1" :class="menuPositionStatus?'menuBox':'menuBoxFixed'">
      <div class="menuBlock">
        <div  @click.prevent="custormAnchor(`top${index}`, index)" :class="currentMenuListIndex === index ? 'menu-item-select':''" v-for="(item, index) in menuList" :style="`width: ${100 / menuList.length}%`" :key="index" class="menu-item">
          {{item.name}}
        </div>
      </div>
    </div>
    <div class="content">
      <div :id="`top${index}`" class="content-item" :style="(index + 1 )%2 === 0?'background:#fff':''" v-for="(item, index) in list">
        <div class="class-block">
          <div class="titleBox">
             <div class="one">{{item.describes}}</div>
          </div>
          <div class="optionBox">
            <div :style="(indexs + 1)%8 === 0 ? 'margin-right: 0px':''" @click="onOption(index,indexs)" :class="item.selectClass === indexs?'optionSelect':'optionItem'" v-for="(items,indexs) in item.list">
              {{items.name | optionNameLenFilter}}
            </div>
          </div>
          <div v-if="item.contentList && item.contentList.length > 0 " class="classBox" :style="item.isOpen? `height:${item.boxHeight}px`:'height: 440px'">
            <div class="classBox-item" @click="onItem(itemss)" v-for="(itemss, indexss) in item.contentList" :style="(indexss + 1)%4 === 0 ? 'margin-right: 0px':''">
              <img :src="$apiConfig.REQUEST_URL + '/shall' +itemss.icon" alt="">
              <div class="bottomBox">
                <div class="bottomBox-title">{{itemss.name}}</div>
                <div class="bottomBox-more">查看更多</div>
              </div>
            </div>
          </div>
          <div class="moreBox" >
            <div v-if="item.contentList && item.contentList.length > 8" @click="onMore(index)">
              <span>{{item.isOpen ? '收起' : '查看更多'}}</span>
              <img :class="item.isOpen?'imgTop':'imgBottom'" src="../assets/images/shang/jiantou.png" alt="">
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import search from "./mixin/search";
  import serviceDetail from "./mixin/serviceDetail";
  import {deepClone} from "../common/js/deepClone";

  export default {
    name: "digit",
    // mixins: [search, serviceDetail],
    data() {
      return {
        currentSwiperIndex: 0,
        menuList: [],
        currentMenuListIndex: 0,
        list: [],
        menuPositionStatus: true
      }
    },
    filters: {
      optionNameLenFilter(e) {
        let obj = ''
        if (e.length > 8) {
          obj = e.substring(0, 8) + '...'
        } else {
          obj = e
        }
        return obj
      }
    },
    mounted() {
      this.getClassList()
      window.onscroll = (e) => {
        console.log(e);
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        console.log("滚动距离" + scrollTop);
        let aa = this.menuList.findIndex((element) => element.topPx > scrollTop)
        console.log(aa);
        if (aa === -1) {
          this.currentMenuListIndex = this.menuList.length
        } else {
          this.currentMenuListIndex = aa
        }

        if (scrollTop >= 400) {
          console.log('吸顶')
          this.menuPositionStatus = false
        } else if (scrollTop < 400) {
          this.menuPositionStatus = true
        }
      }

    },
    methods: {
      custormAnchor(anchorName,index) {
        this.currentMenuListIndex = index
        let anchorElement = document.getElementById(anchorName)
        if(anchorElement) { anchorElement.scrollIntoView({
          behavior: "smooth",  // 平滑过渡
          block:    "end"  // 上边框与视窗顶部平齐。默认值
        }); }
      },
      carouselChange(n, o) {
        this.currentSwiperIndex = n
      },
      async onOption (index, indexs) {
        this.list[index].contentList = []
        this.list[index].selectClass = indexs
        this.list[index].contentList = await this.getContentList(this.list[index].list[indexs].sort)
        this.list[index].boxHeight = Math.ceil(this.list[index].contentList.length / 4) * 220

        this.$forceUpdate();
      },
      async getClassList() {
        let resp = await this.$axios.post(this.$apiConfig.REQUEST_URL + '/shall/front_getBigScreenSort')
        this.menuList = deepClone(resp.data.data)
        this.list = deepClone(resp.data.data)
        this.list.forEach((item,i)=>{
          item.isOpen = true
          this.onOption(i,0)
        })
        // for await (const item of this.list) {
        //   item.selectClass = 0
        //   item.contentList = await this.getContentList(item.list[0].sort)
        //   item.isOpen = false
        //   item.boxHeight = Math.ceil(item.contentList.length / 4) * 220
        //   console.log(item,6666666666666666666666);
        // }
        this.$nextTick(() => {
          console.log(this.menuList);
          this.menuList.forEach((item,index) => {
            setTimeout(() => {
              item.topPx = document.getElementById(`top${index}`).getBoundingClientRect().top
            }, 1000)
          })
        })
      },
      async getContentList (e) {
        return new Promise( async (resolve, reject) => {
          let resp = await this.$axios.post(this.$apiConfig.REQUEST_URL + '/shall/front_getBigScreenListBySort?' + this.$qs.stringify({
            sort: e
          }))
          this.$apiConfig.resultHandle(resp, (result) => {
            resolve(result.data)
          }, (err) => {
            reject(err)
          })
        })
      },
      onMore(e) {
        console.log(this.list);
        this.list[e].isOpen = !this.list[e].isOpen
        this.$forceUpdate();
      },
      onItem(e) {
        console.log(e);
        window.open(e.url)
      },
      toService(payload) {
        let paramStr = payload ? this.$qs.stringify(payload) : null
        this.$router.push(`/service?${paramStr}`)
      },
    }
  }
</script>
<style lang="stylus">
  .el-carousel__arrow
    position fixed !important
    top 10000% !important
    left 10000% !important

  .el-carousel__indicators--horizontal
    left 0 !important
    bottom 45px !important
    transform translateX(0%) !important

    .el-carousel__button
      width 30px !important
      height 4px !important
      border-radius 1.5px !important
      background #6B93D6 !important

    .is-active
      .el-carousel__button
        background #fff !important

</style>
<style lang="stylus" scoped>
  @import "../common/stylus/config.styl"
  @import "../common/stylus/placeholder.styl"
  .datanalysis
    //@import "~common/stylus/search.styl"

    .swiperBox
      width 100%
      height 478px
      background #1948a2
      //overflow hidden
      border 1px solid #00286a
      position relative
      background-image url("../assets/images/shang/ssbanner-bg.jpg")
      background-repeat no-repeat
      background-size auto 478px
      background-position bottom
      // margin-top -84px
      // padding-top 84px
      overflow hidden

      .carouselBox
        width 1200px
        margin 0 auto
        position relative

        &>>>.el-carousel__indicators
          display none

        .block
          width 100%
          height 100%
          position absolute
          top 0
          left 0

          .itemBox
            width 100%
            height 100%
            position relative
            animation bannerShow 0.5s

            .textBox
              height 100%
              position absolute
              left 0
              top 114px
              animation text 1s

              .title
                font-size 36px
                color #fff
                line-height 42px

              .tip
                font-size 16px
                color #fff
                margin-top 32px

            .iconBox
              width 500px
              position absolute
              right 0
              top 0
              animation icon 1s

              img
                width 100%
                height 100%
    @keyframes bannerShow
      from
        opacity 0
      to
        opacity 1
    @keyframes icon
      0%
        transform scale(1)
      25%
        transform scale(.95)
      50%
        transform scale(1)
      75%
        transform scale(.95)
      100%
        transform scale(1)
    @keyframes text
      0%
        transform translate(0, 0)
      25%
        transform translate(0, 6px)
      50%
        transform translate(0, 0)
      75%
        transform translate(0, 6px)
      100%
        transform translate(0, 0)
    @keyframes classBoxShow
      from
        opacity 0
      to
        opacity 1
  .menuBoxFixed
     width 100%
     height 56px
     background #fff
     position fixed
     top 84px
     left 0
     z-index 99999
     border-bottom 1px solid #f4f6f9
     box-shadow 0 10px 10px #eee

    .menuBlock
       width 1200px
       height 100%
       margin 0 auto
       .menu-item-select
         background #F4F4F4
         color #003A9A
       .menu-item
         float left
         text-align center
         line-height 56px
         cursor pointer

         &:hover
           background #F4F4F4
           color #003A9A

  .menuBox
      width 100%
      height 56px
      background #fff
      border-bottom 1px solid #f4f6f9


      .menuBlock
        width 1200px
        height 100%
        margin 0 auto

        .menu-item
          float left
          text-align center
          line-height 56px
          cursor pointer

          &:hover
            background #F4F4F4
            color #003A9A

    .content
      width 100%

      .content-item
        width 100%
        min-height 629px

        .class-block
          width 1200px
          margin 0 auto
          padding-bottom 60px

          .titleBox
            width 100%
            padding-top 54px


            .one
              font-size 28px
              color #333
              text-align center

            .two
              font-size 14px
              color #b2b2b2
              margin-top 15px
              text-align center

          .optionBox
            width 100%
            margin-top 46px

            .optionItem
              width 138px
              height 38px
              background red
              display inline-block
              margin-right 13px
              margin-bottom 13px
              font-size 14px
              text-align center
              line-height 38px
              border 1px solid #E5E5E5
              background linear-gradient(0deg, #FFFFFF 0%, #F3F5F8 100%)
              box-shadow 0 0 18px 0 rgba(9, 48, 81, 0.03)
              color #666666
              cursor pointer

            .optionSelect
              width 138px
              height 38px
              background red
              display inline-block
              margin-right 13px
              margin-bottom 13px
              font-size 14px
              text-align center
              line-height 38px
              border 1px solid #CBDBF7
              background linear-gradient(0deg, #FFFFFF 0%, #E4EBF7 100%)
              box-shadow 0 6px 18px 0 rgba(121, 131, 148, 0.38)
              color #003A9A

          .classBox
            width 100%
            margin-top 29px
            overflow hidden
            transition height 0.3s
            animation classBoxShow .9s
            .classBox-item
              width 288px
              height 204px
              background #FFFFFF
              display inline-block
              margin-right 16px
              margin-bottom 16px
              border 1px solid #E5E5E5
              padding-bottom 47px
              position relative
              cursor pointer
              overflow hidden

              &:hover .bottomBox
                bottom 0

              img
                width 100%
                height 100%

              .bottomBox
                width 100%
                height 86px
                position absolute
                bottom -39px
                left 0
                transition bottom 0.2s

                .bottomBox-title
                  width 100%
                  height 47px
                  line-height 47px
                  padding 0 19px
                  box-sizing border-box
                  background #fff
                  font-size 18px
                  overflow hidden
                  white-space nowrap
                  text-overflow ellipsis
                  -o-text-overflow ellipsis
                .bottomBox-more
                  width 100%
                  height 39px
                  text-align center
                  line-height 39px
                  background #003a9a
                  color #FFFFFF
                  font-size 14px
          .moreBox
            width 100%
            height 80px
            text-align center

            span
              color #003a9a
              font-size 14px
              line-height 80px
              cursor pointer
            img
              width 25px
              height 25px
              position relative
              top 8px
              cursor pointer
              transition transform .3s
            .imgTop
              transform rotate(180deg)
            .imgBottom
              transform rotate(0deg)
  //.content
  //  width 100%
  //
  //  .content-item
  //    width 100%
  //    min-height 629px
  //
  //    .class-block
  //      width 1200px
  //      margin 0 auto
  //
  //      .classTitle
  //        width 100%
  //        height 130px
  //        line-height 130px
  //        font-size 28px
  //        color #333
  //
  //      .classBox
  //        width 100%
  //        overflow hidden
  //        transition height 0.3s
  //
  //        .classBox-item
  //          width 288px
  //          height 204px
  //          background #FFFFFF
  //          display inline-block
  //          margin-right 16px
  //          margin-bottom 16px
  //          border 1px solid #E5E5E5
  //          padding-bottom 47px
  //          position relative
  //          cursor pointer
  //          overflow hidden
  //
  //          &:hover .menuBox
  //            bottom 0
  //
  //          img
  //            width 100%
  //            height 100%
  //
  //          .menuBox
  //            width 100%
  //            height 86px
  //            position absolute
  //            bottom -39px
  //            left 0
  //            transition bottom 0.2s
  //
  //            .menuBox-title
  //              width 100%
  //              height 47px
  //              line-height 47px
  //              padding 0 19px
  //              box-sizing border-box
  //              background #fff
  //              font-size 18px
  //
  //            .menuBox-more
  //              width 100%
  //              height 39px
  //              text-align center
  //              line-height 39px
  //              background #003a9a
  //              color #FFFFFF
  //              font-size 14px
  //
  //      .moreBox
  //        width 100%
  //        text-align center
  //
  //        span
  //          color #003a9a
  //          font-size 14px
  //          line-height 80px
  //          cursor pointer
</style>



// WEBPACK FOOTER //
// src/pages/digit.vue